"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviousBookingsControl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _Checkbox = _interopRequireDefault(require("../../../../../../../ui/Checkbox"));
var _Select = _interopRequireDefault(require("../../../../../../../ui/Select"));
var _Default = _interopRequireDefault(require("../../../../../../../ui/Select/components/Item/Default"));
var _Tooltip = _interopRequireWildcard(require("../../../../../../../ui/Tooltip"));
var _selectors = require("../../../../store/selectors");
var _styles = _interopRequireDefault(require("./styles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PreviousBookingsControl = exports.PreviousBookingsControl = function PreviousBookingsControl(_ref) {
  var changedIDs = _ref.changedIDs,
    onChange = _ref.onChange,
    onHide = _ref.onHide;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowControl = _useState2[0],
    setIsShowControl = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  var options = (0, _reactRedux.useSelector)(_selectors.getPreviousBookings);
  var onSelectItem = (0, _react.useCallback)(function (id) {
    return onChange((0, _ramda.append)(id, changedIDs));
  }, [changedIDs, onChange]);
  var onRemoveItem = (0, _react.useCallback)(function (id) {
    return onChange((0, _ramda.without)([id], changedIDs));
  }, [changedIDs, onChange]);
  var onToggleVisibilityControl = (0, _react.useCallback)(function () {
    return setIsShowControl(function (prevState) {
      var next = !prevState;
      if (!next) {
        onHide();
      }
      return next;
    });
  }, [onHide]);
  var mappedOptions = (0, _react.useMemo)(function () {
    return (0, _ramda.map)((0, _ramda.ifElse)(function (_ref2) {
      var value = _ref2.value;
      return (0, _ramda.includes)(value, changedIDs);
    }, (0, _ramda.assoc)('disabled', true), _ramda.identity), options);
  }, [options, changedIDs]);
  var disabled = (0, _ramda.isEmpty)(mappedOptions);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tooltip.default.RenderWhen, {
    content: t('PREVIOUS_BOOKINGS_HINT'),
    isTrue: disabled,
    placement: _Tooltip.PLACEMENTS.TOP_LEFT,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    disabled: disabled,
    checked: isShowControl,
    className: _styles.default.checkbox,
    label: t('PREVIOUS_BOOKINGS_CHECKBOX_LABEL'),
    onChange: onToggleVisibilityControl
  })), isShowControl && /*#__PURE__*/_react.default.createElement(_Select.default, {
    multiple: true,
    className: _styles.default.root,
    classNameHeader: _styles.default.wrapper,
    itemComponent: _Default.default,
    items: mappedOptions,
    value: changedIDs,
    onChange: onSelectItem,
    onRemove: onRemoveItem
  }));
};
PreviousBookingsControl.propTypes = {
  changedIDs: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onHide: _propTypes.default.func.isRequired
};